<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Delete Action :: MeritEHS'"/>

            <corrective-action-breadcrumbs :action="action" mode="Delete"></corrective-action-breadcrumbs>

            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card">
                        <div class="card-header"><strong>Delete Corrective Action</strong></div>
                        <div class="card-body">
                            <div class="alert alert-danger"><strong>Warning:</strong> This will permanently delete the Corrective Action and all files attached. This change is irreversible. Are you sure you want to continue?.</div>
                            <hr/>

                            <template v-if="files && files.length > 0">
                                <label>Files that will be deleted:</label><br/>
                                <file-list :files="files" />
                            </template>
                            <template v-else>
                                -- No Files --
                            </template>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-danger" v-on:click="deleteAction(this)" :disabled="saving">Delete Corrective Action</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                corrective_action_id: this.$route.params.id,
                action: {},
                files: [],
            }
        },
        methods: {
            getAction: function() {
                //Get the data
                this.$http
                    .get('corrective-actions/view/' + this.corrective_action_id)
                    .then(response => {
                        //Set all the data
                        this.action = response.data.action;
                        this.files = response.data.files;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteAction() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('corrective-actions/delete/' + this.corrective_action_id)
                .then(response => {
                    //Create the messgae
                    var deleteMessage = 'Corrective Action Deleted';

                    //Alert the user?
                    this.$toastr.success(deleteMessage);

                    //Check the Asset
                    if(this.action.asset_type === 'InspectionResult')
                    {
                        //Return to main list?
                        this.$router.push('/inspections/result/' + this.action.asset_id);
                    }
                    else if (this.action.asset_type === 'Incident')
                    {
                        //Return to main list?
                        this.$router.push('/incidents/view/' + this.action.asset_id);
                    }
                    else
                    {
                        //Return to main list?
                        this.$router.push('/corrective-actions');
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },
        mounted() {
            //Get the incidents
            this.getAction();
        }
    }
</script>
